import { render } from "./Project.vue?vue&type=template&id=86a82f0c&bindings={\"project\":\"props\"}"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"
script.render = render

export default script